'use strict';

var CompetitorsFaresCombinedFilterController = function CompetitorsFaresCombinedFilterController($scope) {
  $scope.modalOpen = false;
  $scope.toggleModal = function () {
    $scope.modalOpen = !$scope.modalOpen;
  };
  $scope.closeModal = function () {
    $scope.onResetClick();
    $scope.modalOpen = false;
  };
  $scope.updateFilter = function () {
    $scope.updateCallBack();
    $scope.modalOpen = false;
  };
  $scope.onResetClick = function () {
    if ($scope.filterDisplay) {
      $scope.filter.display = 'timeWindowCompFares';
    }
    $scope.filter.matchType.fare = false;
    $scope.filter.matchType.time = false;
  };
  $scope.correctMatchedValues = function (newValue, oldValue) {
    if (oldValue === 'timeWindowCompFares' && newValue !== 'timeWindowCompFares') {
      $scope.filter.matchType.fare = false;
      $scope.filter.matchType.time = false;
    }
  };
  $scope.$on('competitor-fare-chart:resetQuickFilter', $scope.onResetClick);
};
CompetitorsFaresCombinedFilterController.$inject = ['$scope'];
module.exports = CompetitorsFaresCombinedFilterController;